// @flow
import * as React from 'react';
import LoadingSection from './LoadingSection';

type Props = {
  error: ?Error,
  pastDelay: boolean
};

export default class LoadableLoadingSection extends React.PureComponent<Props> {
  render() {
    if (this.props.error) {
      throw this.props.error;
    }
    if (this.props.pastDelay) {
      return <LoadingSection delay={0} />;
    }
    return null;
  }
}
